import keycode from "keycode";

/**
 * Return a function that will call `callback` when called with a keyboard event
 * matching a space or enter
 */
export function keyboardEventPassthroughHandler(callback) {
  return (event) => {
    switch (keycode(event).toLowerCase()) {
      case "enter":
      case "space":
        event.preventDefault();
        event.stopPropagation();

        callback?.(event);
    }
  };
}
